import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { usePageTracker } from './hooks/usePageTracker';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/Dashboard';
import BookOfRecord from './pages/BookOfRecord';
import Ledger from './pages/Ledger';
import NAVPricing from './pages/NAVPricing';
import OrderCrossing from './pages/OrderCrossing';
import Predictions from './pages/Predictions';
import Rebalancing from './pages/Rebalancing';
import LoginPage from './pages/LoginPage';
import AuthCallback from './pages/AuthCallback';
import ActivityLog from './pages/ActivityLog';
import Settings from './pages/Settings';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-4 border-[#FF8C42] border-t-transparent rounded-full animate-spin" />
          <p className="text-gray-500 text-sm">Loading <span style={{ fontFamily: 'Georgia, serif' }}>trove helix<span className="text-[#FF8C42]">.</span></span></p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function TrackedRoutes() {
  usePageTracker();
  return (
    <Routes>
      <Route element={
        <ProtectedRoute>
          <AdminLayout />
        </ProtectedRoute>
      }>
        <Route path="/" element={<Dashboard />} />
        <Route path="/book-of-record" element={<BookOfRecord />} />
        <Route path="/ledger" element={<Ledger />} />
        <Route path="/nav-pricing" element={<NAVPricing />} />
        <Route path="/order-crossing" element={<OrderCrossing />} />
        <Route path="/predictions" element={<Predictions />} />
        <Route path="/rebalancing" element={<Rebalancing />} />
        <Route path="/activity" element={<ActivityLog />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="/login" element={<LoginPage />} />
    </Routes>
  );
}

function AppRouter() {
  // Check the BROWSER's hash (window.location.hash) for session_id
  // HashRouter uses # for routing, so OAuth callback #session_id=xxx gets interpreted as a path
  // We must check window.location.hash directly before the router processes it
  const browserHash = window.location.hash || '';
  
  if (browserHash.includes('session_id=')) {
    return <AuthCallback />;
  }

  return <TrackedRoutes />;
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </Router>
  );
}

export default App;
